import { memo, useState } from "react";
import { Box } from "@mui/material";

import SondertagHeader from "./SondertagHeader";
import SondertageContent from "./SondertageContent";
import useSonderDialogs from "../hooks/useSonderDialogs";

function SondertageBody() {
  /* ---------------- UI STATE ---------------- */
  const [viewMode, setViewMode] = useState("all");

  const dialogs = useSonderDialogs();
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0, // ✅ IMPORTANT (fixes flex overflow issues)
      }}
    >
      {/* ✅ HEADER (does NOT scroll) */}
      <SondertagHeader
        viewMode={viewMode}
        setViewMode={setViewMode}
        dialogs={dialogs}
      />

      {/* ✅ ONLY THIS SCROLLS */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0, // ✅ critical
          pb: "3rem",
        }}
      >
        <SondertageContent viewMode={viewMode} dialogs={dialogs} />
      </Box>
    </Box>
  );
}

export default memo(SondertageBody);
